/************************************
MODULE:         Secondary navigation
WHAT IT DOES:   Funcationality of content navigation (looking like dropdown)
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else { root.returnExports = factory(root.jQuery); }
}(this, function ($) {
    var isInited = false,
        isOpened = false,
        tween = null,
        opener,
        menu = $('.js-nav-secondary'),
        menuBodyWrapper,
        menuBody = $('.js-nav-secondary > ul'),
        menuBodyMinHeight;

    function init() {
        if (isInited)
            return;

        if (window.App.globals.isMobileView) {
            mount();
        }

        var TweenMax = require('tweenmax');
        $(window).on('resize:finished', resize);
    }

    function resize(){
        if(isInited && isOpened) {
            close();
        }
        if(!isInited && window.App.globals.isMobileView) {
            mount();
        } else if (isInited && !window.App.globals.isMobileView) {
            unmount();
        } else {
            return true;
        }

    }

    function mount(){
        var openerArchetype = menu.find('.js-secondary-subnav .Highlighted').length ? menu.find('.js-secondary-subnav .Highlighted') : menu.find('.Highlighted');
        isInited = true;

        openerArchetype.children('a').clone().prependTo(menu).addClass('js-nav-secondary-opener').append('<svg class="icon icon-chevron-down"><use xlink:href="#icon-chevron-down"></use></svg>');
        opener = $('.js-nav-secondary-opener');
        menuBody.wrap('<div class="nav__body js-nav-secondary-wrap"></div>');
        menuBodyWrapper = $('.js-nav-secondary-wrap');
        menuBodyMinHeight = menuBody.outerHeight();
        if (!opener.length || !menu.length )
            return;
        opener.on('click', openerClickProcess);
    }

    function unmount(){
        isInited = false;
        menuBody.unwrap();
        if(opener.length) {
            opener.off('click').remove();
        }
    }

    function openerClickProcess(e) {
        if (typeof e != 'undefined' && typeof e.preventDefault == "function") {
            e.preventDefault();
        }

        if (isOpened)
            close();
        else
            open();
    }

    function open() {
        tweenKill();
        isOpened = true;
        var scrollToOffset = menu.offset().top;
        tween = new TimelineMax({ onComplete: animationComplete });
        tween.fromTo(menuBodyWrapper, 0.5, { minHeight: '0px' }, { minHeight: menuBodyMinHeight, ease: "easeOut" }, 0);
        tween.to( $('html, body'), 0.5, { scrollTop: scrollToOffset, ease: "easeOut" }, "-=0.5");
        tween.play();
    }

    function close() {
        tweenKill();
        isOpened = false;
        tween = new TimelineMax({ onComplete: animationComplete });
        tween.fromTo(menuBodyWrapper, 0.5, { height: menuBodyMinHeight }, { height: '0px', ease: "easeOut" }, 0);
        tween.play();
    }

    function animationComplete() {
        menuBodyWrapper = $('.js-nav-secondary-wrap');
        menuBodyWrapper.removeAttr('style');
        menu[menu.hasClass('is-opened') ? 'removeClass' : "addClass"]('is-opened');
    }

    function tweenKill() {
        if (typeof tween == 'undefined' || tween == null)
            return;

        if (typeof tween.progress == 'function' && tween.progress() < 1) {
            tween.pause();
            tween.progress(1);
        }

        if (typeof tween.destroy == 'function') {
            tween.destroy();
        }
    }


    return {
        init: init
    };

}));


/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.secondarynav.js
 ** module id = 54
 ** module chunks = 24
 **/